import React, { useState, useEffect } from "react";
import { Row, Col, Card, CardBody } from "reactstrap";
import ReactApexChart from "react-apexcharts";

const SalesAnalytics = (props) => {
  const { source } = props;
  const [series, setSeries] = useState([38, 26, 14]);
  const [options, setOptions] = useState({
    labels: ["Online", "Offline", "Marketing"],
    plotOptions: {
      pie: {
        donut: {
          size: '75%'
        }
      }
    },
    legend: {
      show: false,
    },
    colors: ['#3b5de7', '#45cb85', '#eeb902', '#ff0000', '#ff33cc', '#009999'],
  });

  useEffect(() => {
    if (source) {
      modifyData();
    }
  }, [source]);

  const modifyData = () => {
    let labels = [], seriesTemp = [];
    source.map((item) => {
      labels.push(item?._id?.source);
      seriesTemp.push(item?.count);
    });
    setOptions({ ...options, labels });
    setSeries(seriesTemp);
  }

  return (
    <React.Fragment>
      <Card>
        <CardBody>
          <h4 className="card-title mb-4">Source Analytics</h4>

          <Row className="align-items-center" style={{height:260}}>
            <Col sm={6}>
              <ReactApexChart
                options={options}
                series={series}
                type="donut"
                height={245}
                className="apex-charts"
              />
            </Col>
            <Col sm={6}>
              <div>
                <Row>
                  {source.map((item, index) => {
                    if(index<6)
                    return (
                      <div className="col-6" key={item?._id?.source}>
                        <div className="py-3" style={{textAlignLast:'center'}}>
                          <p className="mb-1 text-truncate"><i
                            className="mdi mdi-circle me-1" style={{color:options?.colors[index]}}></i>{" "}{item?._id?.source}
                          </p>
                          <h5>{item?.count}</h5>
                        </div>
                      </div>
                    )
                  })}
                  {/* <div className="col-6">
                    <div className="py-3">
                      <p className="mb-1 text-truncate"><i
                        className="mdi mdi-circle text-success me-1"></i>{" "}Offline</p>
                      <h5>$ 2,284</h5>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="py-3">
                      <p className="mb-1 text-truncate"><i
                        className="mdi mdi-circle text-warning me-1"></i>{" "}Marketing</p>
                      <h5>$ 1,753</h5>
                    </div>
                  </div> */}
                </Row>
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

export default SalesAnalytics;
